<template>
  <v-container fluid>
    {{ estadoPago }} {{ error }}
    <v-row justify="center">
      <v-col xs="12">
        <v-card dense>
          <v-card-title>
            <div class="title mb-1">Pago con tarjeta</div>
            <v-spacer></v-spacer>
            <v-btn fab x-small color="success" @click="isVisible = false">
              <v-icon dark>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text v-if="mostrarFormularioPago">
            <v-row v-if="true">
              <v-col cols="auto"> OrderId: {{ orderId }} </v-col>
            </v-row>

            <v-row v-if="true">
              <formulario-coin-pago
                v-on:token-generado="pagoRealizado($event)"
                :importe="importeAPagar"
                :creditoId="selectedCredito.creditoId"
                :empresaId="selectedCredito.empresaId"
                :orderId="orderId"
              ></formulario-coin-pago>
            </v-row>
            <v-row v-else>
              <v-container>
                <v-row> Importe Total: {{ importeAPagar }} </v-row>
                <v-row> Excepcion: {{ solicitarExcepcion }} </v-row>
                <v-row>
                  Importe A Aplicar Total: {{ importeAplicarTotal }}
                </v-row>
                <v-row> Importe A Cuota: {{ importeAplicarCuota }} </v-row>
                <v-row>
                  Importe A Punitorio: {{ importeAplicarPunitorio }}
                </v-row>
                <v-row> Importe A Cargos: {{ importeAplicarCargos }} </v-row>
              </v-container>
              <v-btn
                @click="
                  pagoRealizado({
                    numeroAutorizacion: '1234',
                    numeroTarjetaTapado: '0000****00000000',
                  })
                "
                >TEST Pago Realizado</v-btn
              >
            </v-row>
          </v-card-text>

          <v-container fluid v-if="status != 'pending'">
            <v-row justify="center">
              <v-col v-if="loading" xs="12" sm="12">
                <v-card v-if="loading" color="primary" dark>
                  <v-card-text>
                    Aguarde un instante, su pago está siendo aplicado...
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col v-else xs="12" sm="12">
                <v-alert
                  :type="estadoPago == 'Pago Aplicado' ? 'success' : 'warning'"
                >
                  {{ alertText }}
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { mapGetters, mapMutations } from 'vuex';

// import FormularioCoin from './FormularioCoin'
import FormularioCoinPago from './FormularioCoinPago';

import { format } from 'date-fns';

export default {
  components: {
    // 'formulario-coin': FormularioCoin,
    'formulario-coin-pago': FormularioCoinPago,
  },
  data: () => ({
    loading: false,
    //   mostrarFormulario: true,
    mostrarFormularioPago: true,
    status: 'pending',
    error: '',
    comprobantePago: {},
    datosContacto: {},
    orderId: null,
  }),
  props: {
    selectedCredito: {
      type: Object,
      required: false,
      default: null,
    },
    cuotasAPagar: {
      type: Array,
      required: false,
      default: null,
    },
    visible: { type: Boolean, default: false },
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    tipoPagoCuota: {
      type: String,
      required: false,
      default: null,
    },
    solicitarExcepcion: {
      type: Boolean,
      required: false,
      default: null,
    },
    importeAplicarTotal: {
      type: Number,
      required: false,
      default: 0,
    },
    importeAplicarCuota: {
      type: Number,
      required: false,
      default: 0,
    },
    importeAplicarPunitorio: {
      type: Number,
      required: false,
      default: 0,
    },
    importeAplicarCargos: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  watch: {
    async isVisible(value) {
      console.log('watching');
      if (value) {
        await this.crearOrdenDePago();
      }
    },
  },
  computed: {
    ...mapGetters([
      'user',
      'UiCustomUserSettings',
      'DebugModeOn',
      'getActionFromLink',
    ]),
    isVisible: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        console.log('emitting');
        this.$emit('update:visivility', value);
      },
    },
    importeAPagar() {
      if (this.tipoPagoCuota == 'excepcion') {
        if (this.solicitarExcepcion)
          return (
            parseFloat(this.importeAplicarCuota) +
            parseFloat(this.importeAplicarPunitorio) +
            parseFloat(this.importeAplicarCargos)
          );
        else return this.importeAplicarTotal;
      } else {
        if (this.cuotasAPagar.length == 0) return 0;

        return this.cuotasAPagar.map((i) => i.saldo).reduce((a, b) => a + b, 0);
      }
    },
    estadoPago() {
      if (this.status == 'pending') return 'Aplicación Pendiente';
      else if (this.error != '') return 'Error Aplicacion';
      else return 'Pago Aplicado';
    },
    alertText() {
      if (this.status == 'pending') return 'Aplicación Pendiente';
      if (this.status == 'approved')
        return 'Transacción Exitosa. Aplicacando en Sistema.';
      else if (this.error != '')
        return 'Su pago fue procesado pero no se pudo imputar en su cuenta corriente. Comuníquese con la empresa para informar su situación.';
      else
        return 'Su pago fue aprobado con éxito! Será redirigido al menú principal.';
    },
  },
  async created() {
    Vue.$log.debug('CONFIRMACION PAGO');
    Vue.$log.debug(this.selectedCredito);
    Vue.$log.debug(this.cuotasAPagar);
    Vue.$log.debug(this.cuotasAPagar.map((x) => x.cuota));
    Vue.$log.debug(this.tipoPagoCuota);

    await this.crearOrdenDePago();
  },
  filters: {
    formatDate: function (value) {
      if (value) return format(value, 'DD-MM-YYYY');
    },
    formatMoney: function (value) {
      if (value) {
        if (Number.isInteger(value)) return '$ ' + value + '.00';
        else return '$ ' + value;
      }
    },
  },
  methods: {
    ...mapMutations(['alertError']),
    async pagoRealizado(datosPago) {
      Vue.$log.debug(datosPago);
      this.mostrarFormularioPago = false;
      this.status = 'approved';

      await this.aplicarPago();
    },
    async crearOrdenDePago() {
      if (!this.selectedCredito || this.importeAPagar == 0) {
        this.error =
          'No se seleccionaron las cuotas a pagar. Por favor repita el proceso.';
        return;
      }

      this.loading = true;

      try {
        const formData = new FormData();

        formData.append('empresaId', this.selectedCredito.empresaId);
        formData.append('medioPagoWebDescripcion', 'Coin');
        formData.append('personaUsuarioId', this.personaId);
        formData.append(
          'tipoDeudaId',
          this.selectedCredito.productoDescripcion == 'Acuerdo' ? 2 : 1
        );
        formData.append('deudaId', this.selectedCredito.creditoId);
        formData.append('importe', this.importeAPagar);
        formData.append('comentarios', this.infoCuotasAPagar);
        formData.append('aplicar', false);
        formData.append('pagoSmarter', true);
        formData.append(
          'cuotasAAplicar',
          this.cuotasAPagar.map((x) => x.cuota)
        );
        formData.append('tipoAplicacion', this.tipoPagoCuota);

        formData.append('importeAplicarTotal', this.importeAplicarTotal);
        formData.append('importeAplicarCuota', this.importeAplicarCuota);
        formData.append(
          'importeAplicarPunitorio',
          this.importeAplicarPunitorio
        );
        formData.append('importeAplicarCargos', this.importeAplicarCargos);

        var res = await http.post('pagosweb', formData);
        console.log('order Id:');
        console.log(res);

        this.orderId = res;
      } catch (error) {
        this.status = 'error';
        this.error = error;
      }

      this.loading = false;
    },
    async aplicarPago(datosPago) {
      if (!this.selectedCredito || this.importeAPagar == 0) {
        this.error =
          'No se seleccionaron las cuotas a pagar. Por favor repita el proceso.';
        return;
      }

      this.loading = true;

      try {
        // desde el 27/7/23 se comienza a utilizar IPN , por lo que la aplicación se realiza en el back

        // const formData = new FormData();

        // formData.append('empresaId', this.selectedCredito.empresaId);
        // formData.append('medioPagoWebDescripcion', 'Coin');
        // formData.append('personaUsuarioId', this.personaId);
        // formData.append(
        //   'tipoDeudaId',
        //   this.selectedCredito.productoDescripcion == 'Acuerdo' ? 2 : 1
        // );
        // formData.append('deudaId', this.selectedCredito.creditoId);
        // formData.append('importe', this.importeAPagar);
        // formData.append(
        //   'comentarios',
        //   this.infoCuotasAPagar +
        //     ' / Nº Aut.:' +
        //     datosPago.numeroAutorizacion +
        //     ' / Card Nº.:' +
        //     datosPago.numTarjetaTapado
        // );
        // formData.append('aplicar', true);
        // formData.append('pagoSmarter', true);
        // formData.append(
        //   'cuotasAAplicar',
        //   this.cuotasAPagar.map((x) => x.cuota)
        // );
        // formData.append('tipoAplicacion', this.tipoPagoCuota);

        // formData.append('importeAplicarTotal', this.importeAplicarTotal);
        // formData.append('importeAplicarCuota', this.importeAplicarCuota);
        // formData.append(
        //   'importeAplicarPunitorio',
        //   this.importeAplicarPunitorio
        // );
        // formData.append('importeAplicarCargos', this.importeAplicarCargos);

        // await http.post('pagosweb', formData);

        this.status = 'applied';

        await setTimeout(() => {
          this.redirectHome();
        }, 600);
      } catch (error) {
        this.status = 'error';
        this.error = error;
      }

      this.loading = false;
    },
    redirectHome() {
      console.log('redirectHome');
      this.$emit('update:visivility', false);
      this.$emit('update:pagoOk', true);
    },
  },
};
</script>
